import React, { useEffect, useState } from 'react'
import CategoriesBar from '../CategoriesBar/CategoriesBar';
import FilterBar from '../FilterBar/FilterBar';
import "./ContentArea.css"
import CardRender from '../CardComponent/CardRender';
import SideBar from '../SideBar/SideBar';
import axiosApiInstance from '../axios';
import { ListItemText } from '@material-ui/core';
import AllTicketsHeader from '../AllTickets/AllTicketsHeader';

const limit = 10;
let scrollDebounce = false;

const ContentArea = () => {

    const [parent, setParent] = useState([])
    const [loading, setLoading] = useState(true)
    const [fdata, setFdata] = useState([])
    const [name, setName] = useState('');
    const [us, setUs] = useState('');
    const [pri, setPri] = useState('');
    const [stopPagination, setStopPagination] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    let pageNumber = 1;

    const setCat = (name) => {
        setName(name);
    }

    const setStat = (us) => {
        setUs(us)
    }

    const setRity = (pri) => {
        setPri(pri)
    }

    const loadMore = () => {
        if (!stopPagination) {
            axiosApiInstance.get(`/ticket/${pageNumber}/${limit}`)
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.data.length < limit) {
                            setLoading(false)
                            setStopPagination(prevValue => {
                                return true;
                            });
                        }

                        setParent(prevState => [...prevState, ...res.data.data]);
                        pageNumber += 1;
                    }
                })
        }

    }

    const handleScroll = (e) => {
        if (window.innerHeight + e.target.documentElement.scrollTop + 2 >= e.target.documentElement.scrollHeight && !stopPagination && !scrollDebounce) {
            scrollDebounce = true;
            loadMore();
            setTimeout(function () { scrollDebounce = false; }, 500);
        }
    }

    useEffect(() => {
        loadMore();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [stopPagination])

    const [state, setState] = useState('');
    const [data, setData] = useState(parent)


    useEffect(() => { setData(parent) }, [parent])

    useEffect(() => {
        setFdata(data);
    }, [data]);

    const searchHandler = (searchTerm) => {
        setSearchTerm(searchTerm)
    }

    return (
        <>
            <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm}  />
            <SideBar />
            <div className="content-area">
                <CategoriesBar setCat={setCat} name={name} />
                <FilterBar us={us} setStat={setStat} pri={pri} setRity={setRity} />
                <CardRender parent={fdata} searchFil={{term: searchTerm}} loading={loading} name={name} us={us} pri={pri} />
            </div>
        </>
    )
}

export default ContentArea;
